import { render, staticRenderFns } from "./PermissionDetail.vue?vue&type=template&id=3a818a94&scoped=true"
import script from "./PermissionDetail.vue?vue&type=script&lang=js"
export * from "./PermissionDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a818a94",
  null
  
)

export default component.exports